import { Box, Flex } from "@chakra-ui/layout";
import { Col, Row } from "antd";
import Field from "components/Input/Field";
import InputMoney from "components/Input/InputMoney";
import SelectFracao from "components/Input/SelectFracao";
import SelectIndexador from "components/Input/SelectIndexador";
import { FormArrecadacaoChildrenFormProps } from "./FormArrecadacao";
import { TitleWrapper } from "./TitleWrapper";

interface FormCriarFundoFracaoProps {
  type?: "FRACAO" | "PESO" | "VALOR_MANUAL";
  showArrecadar?: boolean;
}

function FormCriarFundoFracao({
  control,
  watch,
  current,
  type,
  showArrecadar = false,
}: FormArrecadacaoChildrenFormProps & FormCriarFundoFracaoProps) {
  const valor = watch?.("valor");

  return (
    <Flex
      display={current ? undefined : "none"}
      flexDir="column"
      flex={1}
      w="100%"
    >
      <Box as={Row} mb={4} gutter={16}>
        {type === "FRACAO" ? (
          <Col sm={16}>
            <TitleWrapper>Fração*</TitleWrapper>
            <Field
              shouldUnregister
              control={control}
              name="fracaoId"
              rules={{
                required: current,
              }}
              render={({ field, isInvalid }) => (
                <SelectFracao
                  value={field.value}
                  onChange={field.onChange}
                  isInvalid={isInvalid}
                />
              )}
            />
          </Col>
        ) : null}

        {type === "PESO" ? (
          <Col sm={16}>
            <TitleWrapper>Peso</TitleWrapper>
            <Field
              shouldUnregister
              control={control}
              name="indexadorId"
              rules={{
                required: current,
              }}
              render={({ field, isInvalid }) => (
                <SelectIndexador
                  value={field.value}
                  onChange={field.onChange}
                  isInvalid={isInvalid}
                  valorUnitario={valor}
                />
              )}
            />
          </Col>
        ) : null}

        {type === "VALOR_MANUAL" ? (
          <Col sm={16}>
            <TitleWrapper>Valor manual</TitleWrapper>
            <Field
              shouldUnregister
              control={control}
              name="indexadorId"
              rules={{
                required: current,
              }}
              render={({ field, isInvalid }) => (
                <SelectIndexador
                  value={field.value}
                  onChange={field.onChange}
                  isInvalid={isInvalid}
                  valorUnitario={valor}
                />
              )}
            />
          </Col>
        ) : null}
      </Box>

      {showArrecadar ? (
        <Box as={Row} mb={4}>
          <Col sm={5}>
            <Field
              control={control}
              name="percentualRateio"
              rules={{
                required: current,
              }}
              label="Arrecadar (%)"
              render={({ field, isInvalid }) => (
                <InputMoney
                  isInvalid={isInvalid}
                  value={field.value}
                  onChange={field.onChange}
                  maxValue={100}
                />
              )}
            />
          </Col>
        </Box>
      ) : null}
    </Flex>
  );
}

export default FormCriarFundoFracao;
